export default "__VITE_ASSET__Ct5jkDz3__"